import React from "react";
import { Button, Tooltip } from "@material-ui/core";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import ClearIcon from "@material-ui/icons/Clear";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import GavelIcon from "@material-ui/icons/Gavel";

export function SpeakerControls(props) {
  const { hasRequestedTheFloor, active, isSpeakerActive, unassignRequest, requestPointOfOrder, requestTheFloor, settings, orderId, template } = props;

  const { allowPointOfOrder, allowRequestLineOfSpeaker, allowRequestTheFloor } = settings;
  if (!hasRequestedTheFloor) {
    return (
      <div>
        {active && allowPointOfOrder == true ? (
          <Button size="small" style={{ ...template.button, marginRight: 5, paddingRight: 8, paddingLeft: 8 }} disabled={orderId == 1} onClick={requestPointOfOrder} startIcon={<GavelIcon />}>
            <Tooltip title={<EventLabel2 name="PointOfOrder" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />}>
              <EventLabel2 name="PointOfOrder" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />
            </Tooltip>
          </Button>
        ) : null}
        {allowRequestTheFloor == true ? (
          <Button size="small" style={{ ...template.button, paddingRight: 8, paddingLeft: 8 }} onClick={requestTheFloor} disabled={orderId == 1} startIcon={<RecordVoiceOverIcon />}>
            <Tooltip title={<EventLabel2 name="RequestTheFloor" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />}>
              <EventLabel2 name="RequestTheFloor" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />
            </Tooltip>
          </Button>
        ) : null}
      </div>
    );
  } else {
    return allowRequestTheFloor ? (
      <Button size="small" style={{ ...template.button, paddingRight: 8, paddingLeft: 8 }} disabled={isSpeakerActive || orderId == 1} onClick={unassignRequest} startIcon={<ClearIcon />}>
        <Tooltip title={<EventLabel2 name="UnassignRequest" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />}>
          <EventLabel2 name="UnassignRequest" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />
        </Tooltip>
      </Button>
    ) : null;
  }
}
